module.exports = __webpack_public_path__ + "static/media/user-injured.c3f69067.svg";